// Add and use utility functions here to reuse for all components.

export function useUtils() {
  const openLinkInTab = (link, target = "_blank") => {
    window.open(link, target);
  };

  return { openLinkInTab };
}

// The AI Companion module. Mirrors RAG_AI_COMPANION_FEATURE_ID in the API's
// helpers/rag/ragSync.js and AI_COMPANION_FEATURE_ID in helpers/form_guidance.js.
export const AI_COMPANION_FEATURE_ID = 26;

/**
 * Whether the signed-in user's company has bought the AI Companion module.
 *
 * Reads `user.subs`, not `user.comp_settings`. Both exist and they are not
 * interchangeable: comp_settings is every settings row for the company --
 * purchased modules, config toggles and business-type markers share one
 * feature_id namespace -- whereas subs is built by the API (helpers/auth.js)
 * from rows with feature_value = 'functionality', which is what "subscribed to
 * a module" actually means. Feature ids are only unique within a feature_type,
 * so 26 in comp_settings is not necessarily this module.
 *
 * This is presentation only. The API enforces the same subscription on every
 * request to POST /customer_form/guidance.
 *
 * @param {Object} user the user object App.js passes down
 * @returns {boolean}
 */
export function hasAiCompanion(user) {
  return Boolean(user?.subs?.find((s) => s.feature_id === AI_COMPANION_FEATURE_ID));
}
